const hasOwnPrice = (value) => value !== null && value !== undefined && value !== "";

const getCharacteristicPrice = (nomenclature, characteristicId, characteristic, priceKey) => {
  if (characteristic && hasOwnPrice(characteristic[priceKey])) {
    return Number(characteristic[priceKey]);
  }

  if (!nomenclature || !characteristicId) return null;

  const foundCharacteristic = nomenclature.characteristics?.find(
    (item) => Number(item.id) === Number(characteristicId)
  );

  return hasOwnPrice(foundCharacteristic?.[priceKey]) ? Number(foundCharacteristic[priceKey]) : null;
};

export const getCharacteristicSalePrice = (nomenclature, characteristicId, characteristic = null) => {
  return getCharacteristicPrice(nomenclature, characteristicId, characteristic, "salePrice");
};

export const getCharacteristicBuyPrice = (nomenclature, characteristicId, characteristic = null) => {
  return getCharacteristicPrice(nomenclature, characteristicId, characteristic, "minBuyPrice");
};

export const getNomenclatureCustomerPrice = (
  nomenclature,
  characteristicId,
  typePriceId = null,
  characteristic = null
) => {
  const characteristicPrice = getCharacteristicSalePrice(nomenclature, characteristicId, characteristic);
  if (hasOwnPrice(characteristicPrice)) return characteristicPrice;

  if (nomenclature?.typePrices && typePriceId != null) {
    const typePrice = nomenclature.typePrices.find(
      (item) => Number(item.namePrice?.id) === Number(typePriceId)
    );

    if (hasOwnPrice(typePrice?.valueCurrency)) return Number(typePrice.valueCurrency);
  }

  return Number(nomenclature?.salePrice ?? nomenclature?.clientPrice ?? 0);
};

export const getNomenclaturePurchasePrice = (
  nomenclature,
  characteristicId,
  characteristic = null
) => {
  const characteristicPrice = getCharacteristicBuyPrice(nomenclature, characteristicId, characteristic);
  if (hasOwnPrice(characteristicPrice)) return characteristicPrice;

  return Number(nomenclature?.minBuyPrice ?? 0);
};
